/* No apps, network requests or tracking hooks. URL state is limited to four filters. */
(() => {
  document.querySelectorAll('[data-sf]').forEach(root => {
    if (root.dataset.sfReady) return;
    root.dataset.sfReady = 'true';
    const form = root.querySelector('form');
    const keys = ['style','difficulty','length','season'];
    const fields = Object.fromEntries(keys.map(key => [key,form.elements.namedItem(key)]));
    const cards = [...root.querySelectorAll('[data-sf-card]')];
    const total = cards.length;
    const count = root.querySelector('[data-sf-count]');
    const activeList = root.querySelector('[data-sf-active]');
    const clearLink = root.querySelector('.sf-results [data-sf-clear]');
    const empty = root.querySelector('[data-sf-empty]');
    const bespoke = root.querySelector('[data-sf-bespoke]');
    const clean = (key, value) => [...fields[key].options].some(option => option.value === value) ? value : '';
    const label = key => fields[key].options[fields[key].selectedIndex].text;
    const plain = event => !(event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey);
    const read = () => {
      const params = new URL(location.href).searchParams;
      keys.forEach(key => { fields[key].value = clean(key, params.get(key) || ''); });
    };
    const renderActive = state => {
      const active = keys.filter(key => state[key]);
      activeList.replaceChildren(...active.map(key => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sf-chip';
        button.dataset.sfRemove = key;
        button.setAttribute('aria-label', `Remove ${label(key)}`);
        button.innerHTML = `<span></span><svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 3l6 6M9 3l-6 6"/></svg>`;
        button.firstChild.textContent = label(key);
        item.append(button);
        return item;
      }));
      activeList.hidden = !active.length;
      clearLink.hidden = !active.length;
      keys.forEach(key => {
        fields[key].closest('[data-sf-field]').toggleAttribute('data-active', !!state[key]);
        pickers[key].sync();
      });
      return active.length;
    };
    const apply = animate => {
      const state = Object.fromEntries(keys.map(key => [key,fields[key].value]));
      const visible = [];
      for (const card of cards) {
        const days = Number(card.dataset.days);
        const seasons = card.dataset.seasons.split('|');
        const lengthMatch = !state.length || (state.length === 'under-14' && days > 0 && days < 14) || (state.length === '14-20' && days >= 14 && days <= 20) || (state.length === '21-plus' && days >= 21);
        const show = (!state.style || card.dataset.style.split('|').includes(state.style)) && (!state.difficulty || card.dataset.difficulty === state.difficulty) && lengthMatch && (!state.season || seasons.includes(state.season));
        card.hidden = !show;
        card.classList.remove('is-wide','is-fresh');
        if (show) visible.push(card);
      }
      const remainder = visible.length % 3;
      const wide = remainder === 2 ? 2 : remainder === 1 && visible.length > 3 ? 4 : visible.length === 1 ? 1 : 0;
      visible.slice(0,wide).forEach(card => card.classList.add('is-wide'));
      if (animate) {
        void root.offsetWidth;
        visible.forEach(card => card.classList.add('is-fresh'));
      }
      const active = renderActive(state);
      const noun = visible.length === 1 && !active ? 'trip' : 'trips';
      count.innerHTML = active ? `<span class="sf-count__n"></span> of ${total} ${total === 1 ? 'trip' : 'trips'}` : `<span class="sf-count__n"></span> ${noun}`;
      count.firstChild.textContent = visible.length;
      /* Bespoke gets its own introduction, which also stands in for the empty state */
      const bespokeOnly = state.style === 'bespoke';
      if (bespoke) bespoke.hidden = !bespokeOnly;
      empty.hidden = visible.length !== 0 || (bespoke && bespokeOnly && !state.difficulty && !state.length && !state.season);
      root.querySelectorAll('[data-sf-avenue]').forEach(link => {
        const params = new URL(link.href).searchParams;
        const matches = keys.every(key => (params.get(key) || '') === state[key]);
        if (matches) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current');
      });
    };
    const updateUrl = () => {
      const url = new URL(location.href);
      keys.forEach(key => {
        if (fields[key].value) url.searchParams.set(key,fields[key].value); else url.searchParams.delete(key);
      });
      if (!url.searchParams.has('view')) url.searchParams.set('view','finder');
      url.hash = '';
      if (url.href !== location.href) history.pushState(null,'',url);
    };
    const change = () => { updateUrl(); apply(true); };

    /* Filter lists, September 30, 2026: each field is a button that opens a
       list in the site's panel style (the select-only combobox pattern), in
       place of the browser's own option list. The hidden select still holds
       the value and fires the change event, so filtering, chips and URLs are
       unchanged. */
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pickers = {};
    let openPicker = null;
    keys.forEach(key => {
      const select = fields[key];
      const field = select.closest('[data-sf-field]');
      const trigger = field.querySelector('[data-sf-trigger]');
      const list = field.querySelector('[data-sf-list]');
      const value = trigger.querySelector('[data-sf-value]');
      const options = [...select.options].map((option, index) => {
        const item = document.createElement('li');
        item.id = `${list.id}-${index}`;
        item.className = 'sf-option';
        item.setAttribute('role','option');
        item.innerHTML = '<span></span><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8.4l2.9 2.9 6.1-6.6"/></svg>';
        item.firstChild.textContent = option.text;
        return item;
      });
      list.replaceChildren(...options);
      let current = 0;
      let typed = '';
      let typedTimer = 0;
      let skipClick = false;
      const highlight = index => {
        current = Math.max(0, Math.min(options.length - 1, index));
        options.forEach((item, i) => item.classList.toggle('is-current', i === current));
        trigger.setAttribute('aria-activedescendant', options[current].id);
      };
      const sync = () => {
        options.forEach((item, i) => item.setAttribute('aria-selected', i === select.selectedIndex ? 'true' : 'false'));
        value.textContent = label(key);
      };
      const open = index => {
        if (openPicker && openPicker !== picker) openPicker.close();
        sync();
        list.hidden = false;
        trigger.setAttribute('aria-expanded','true');
        field.classList.add('is-open');
        openPicker = picker;
        highlight(index ?? select.selectedIndex);
        /* On a phone the list can open below the fold: bring all of it into view
           (the 6px is the opening slide, the 16px a margin under the list) */
        const overflow = list.getBoundingClientRect().top + 6 + list.offsetHeight + 16 - innerHeight;
        if (overflow > 0) scrollBy({ top: overflow, behavior: reduced ? 'auto' : 'smooth' });
      };
      const close = () => {
        list.hidden = true;
        trigger.setAttribute('aria-expanded','false');
        trigger.removeAttribute('aria-activedescendant');
        field.classList.remove('is-open');
        if (openPicker === picker) openPicker = null;
      };
      const choose = index => {
        close();
        if (select.selectedIndex === index) return;
        select.selectedIndex = index;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const type = character => {
        clearTimeout(typedTimer);
        typedTimer = setTimeout(() => { typed = ''; }, 600);
        typed += character.toLowerCase();
        const order = [...options.slice(current + (typed.length === 1 ? 1 : 0)), ...options.slice(0, current + (typed.length === 1 ? 1 : 0))];
        const match = order.find(item => item.textContent.toLowerCase().startsWith(typed));
        if (match) highlight(options.indexOf(match));
      };
      const printable = event => event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey;
      trigger.addEventListener('keydown', event => {
        const key = event.key;
        if (key === 'Enter' || key === ' ') skipClick = true;
        if (list.hidden) {
          if (['ArrowDown','ArrowUp','Enter',' '].includes(key)) { event.preventDefault(); open(); }
          else if (key === 'Home') { event.preventDefault(); open(0); }
          else if (key === 'End') { event.preventDefault(); open(options.length - 1); }
          else if (printable(event)) { event.preventDefault(); open(); type(key); }
          return;
        }
        if (key === ' ' && typed) { event.preventDefault(); type(key); return; }
        if (key === 'ArrowUp' && event.altKey) { event.preventDefault(); choose(current); return; }
        switch (key) {
          case 'ArrowDown': event.preventDefault(); highlight(current + 1); break;
          case 'ArrowUp': event.preventDefault(); highlight(current - 1); break;
          case 'Home': case 'PageUp': event.preventDefault(); highlight(0); break;
          case 'End': case 'PageDown': event.preventDefault(); highlight(options.length - 1); break;
          case 'Enter': case ' ': event.preventDefault(); choose(current); break;
          case 'Escape': event.preventDefault(); event.stopPropagation(); close(); break;
          case 'Tab': choose(current); break;
          default: if (printable(event)) { event.preventDefault(); type(key); }
        }
      });
      trigger.addEventListener('keyup', () => { setTimeout(() => { skipClick = false; }, 0); });
      /* Mouse, touch and a screen reader's own click all arrive here */
      trigger.addEventListener('click', () => {
        if (skipClick) { skipClick = false; return; }
        if (list.hidden) open(); else close();
      });
      trigger.addEventListener('blur', () => { setTimeout(() => { if (document.activeElement !== trigger && !list.hidden) close(); }, 0); });
      /* Keep focus on the button while an option is pressed */
      list.addEventListener('pointerdown', event => event.preventDefault());
      list.addEventListener('pointermove', event => {
        const item = event.target.closest('[role="option"]');
        if (item && event.pointerType === 'mouse') highlight(options.indexOf(item));
      });
      list.addEventListener('click', event => {
        const item = event.target.closest('[role="option"]');
        if (!item) return;
        choose(options.indexOf(item));
        trigger.focus({ preventScroll: true });
      });
      const picker = pickers[key] = { trigger, sync, close };
    });
    /* A tap outside closes the open list (Safari never focuses the button) */
    document.addEventListener('pointerdown', event => {
      if (openPicker && !openPicker.trigger.closest('[data-sf-field]').contains(event.target)) openPicker.close();
    });

    read();
    keys.forEach(key => { fields[key].disabled = false; pickers[key].trigger.disabled = false; });
    apply(false);
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('change', change);
    root.querySelectorAll('[data-sf-clear]').forEach(link => link.addEventListener('click', event => {
      if (!plain(event)) return;
      event.preventDefault();
      keys.forEach(key => { fields[key].value = ''; });
      change();
      count.focus({ preventScroll: true });
    }));
    activeList.addEventListener('click', event => {
      const button = event.target.closest('[data-sf-remove]');
      if (!button) return;
      const position = [...activeList.children].indexOf(button.parentElement);
      fields[button.dataset.sfRemove].value = '';
      change();
      const next = activeList.children[Math.min(position, activeList.children.length - 1)];
      (next ? next.firstChild : pickers[button.dataset.sfRemove].trigger).focus();
    });
    root.querySelectorAll('[data-sf-avenue]').forEach(link => link.addEventListener('click', event => {
      if (!plain(event)) return;
      event.preventDefault();
      const params = new URL(link.href).searchParams;
      keys.forEach(key => { fields[key].value = clean(key,params.get(key) || ''); });
      change();
    }));
    count.tabIndex = -1;
    addEventListener('popstate', () => { if (openPicker) openPicker.close(); read(); apply(true); });
  });
})();
